import { ButtonBase } from ".";
import { ACTION_STATUS } from "..";

export class SaveAsButtonModel extends ButtonBase {
    label: string = 'Save As';
    action: string = ACTION_STATUS.saveAs;
    matIconName: string;
    colorClass: string;
}